import { render, staticRenderFns } from "./Venta.view.vue?vue&type=template&id=00c8c7c5"
import script from "./Venta.view.vue?vue&type=script&lang=js"
export * from "./Venta.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports